export default {
    key: 'p2p',
    type: 'P2P',
    isUsingProductConfigPresets: true,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    origins: [],
    destinations: [],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: [],
    routeVariantUp: undefined,
    routeVariantDown: undefined,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: undefined,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 60,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    steps: [],
} satisfies ProductConfigP2P;
